module.exports = __webpack_public_path__ + "img/right-part.fdf7b1af.png";